"use strict";
exports.__esModule = true;
exports["default"] = {
    "game.name": "控制台小游戏",
    "tip.start": "输入 start 开始游戏.",
    "tip.start_game": "输入 yes 开始主线任务 输入 help 查看所有互动指令",
    "tip.restart": "如果你想重新开始 请输入 restart",
    "tip.respawn": "输入 respawn 重生并回到主城",
    "tip.beg_prtc": "你就是小比特, 为了拯救后台城, 你来到了修炼社区, 接下来你准备: 开启漫漫修炼之路 (beg_prtc)",
    "tip.shop": "输入 select 来选择商品, 输入 buy 来购买商品",
    "console.warn": "警告",
    "console.err": "危险",
    "weapon.iron_sword": "铁剑",
    "weapon.symbol": "符号剑",
    "weapon.bloodthirsty": "嗜血剑",
    "weapon.bit_sword": "比特剑",
    "weapon.meniscus": "弯月刃",
    "mob.code_mob": "代码怪",
    "mob.small_code_mob": "小代码怪",
    "mob.small_code_mob.crit": ["可恶! 大意了", "啊!! 痛!!!", "你等着我!!!"],
    "mob.medium_code_mob": "中代码怪",
    "mob.medium_code_mob.crit": ["我居然会被一个小喽啰暴击?!", "看我打你!!", "啊!!!"],
    "mob.large_code_mob": "大代码怪",
    "mob.large_code_mob.crit": ["我一脚就能踩死你!!", "操!!!", "你给我小心点..."],
    "mob.super_code_mob": "巨代码怪",
    "mob.super_code_mob.crit": ["这小子还是有几招的!", "看我不打死你!!!", "我去..."],
    "command.help.start": "start 开始游戏 (一次性指令)",
    "command.help.info": "info 查看信息及状态",
    "command.help.beg_prtc": "beg_prtc 开启修炼之门 (一次性指令)",
    "command.help.g_main": "g_main 回到主城",
    "command.help.delsave": "delsave 删除存档并开始新游戏",
    "command.info.level": "等级",
    "command.info.wallet": "钱包",
    "command.info.current_weapon": "手持武器",
    "command.beg_prtc.explaination": "\n\u4FEE\u70BC:\n\n\u6253\u4E00\u4E2A\u5C0F\u4EE3\u7801\u602A\u53470.3 level, \u6253\u4E00\u4E2A\u4E2D\u4EE3\u7801\u602A\u53470.5 level, \u6253\u4E00\u4E2A\u5927\u4EE3\u7801\u602A\u53471 level, \u6253\u5B8C\u5DE8\u578B\u4EE3\u7801\u602A\u540E\u7ED3\u675F\u6E38\u620F,\n\u5927\u4EE3\u7801\u602A\u5C06\u4F1A\u5728\u4F6050 level\u7684\u65F6\u5019\u89E3\u9501, \u5DE8\u578B\u4EE3\u7801\u602A\u662F\u6700\u7EC8boss, \u5C06\u5728\u4F6099 level\u65F6\u89E3\u9501.\n\n\u4F7F\u7528\u952E\u76D8 \"W\" \"A\" \"S\" \"D\" \u952E\u6765\u5237\u602A.\n\u53BB\u526F\u672C\u4FEE\u70BC (g_prtc) \u53BB\u4E3B\u57CE (g_main)\n",
    "group.commands": "互动指令",
    "group.info": "信息&状态",
    "group.hub": "[主城] 可进入的传送点",
    "group.shop": "商店货架",
    "npc.system": "系统",
    "npc.guide": "向导",
    "npc.shop": "商店",
    "npc.little_bit": "小比特",
    "npc.old_bit": "老比特",
    "message.death": "你被 %s 杀死了",
    "message.attack": "你攻击了一下怪物 怪物当前血量: %s",
    "message.kill": "你消灭了一只怪物",
    "message.selected": "你选中了商品 %c%s",
    "message.bought": "感谢购买! 你的钱包现在还剩 %s$",
    "message.hurt": "你受到了 %s 点伤害",
    "message.got_level": "你获得了 %c经验 * %s%c 可通过指令 info 查询",
    "message.got_money": "你获得了 %c钱 * %s%c 可通过指令 info 查询",
    "message.got_weapon": "你获得了 %c%s(level %e) * 1%c 可通过指令 info 查询",
    "message.unlock": "你的等级达到了 %c%s%c, 已解锁 %c%e%c!",
    "message.cant_afford": "你没有足够的钱够买这件商品!",
    "text.npc1": "游戏开始! glhf!",
    "text.npc2": "你好, 欢迎来到控制台的世界! 我是你的向导. 现在, 我将为你介绍在下面的游戏中会出现的消息类型:",
    "text.npc3": "这是警报",
    "text.npc4": "这是危险",
    "text.npc5": "游戏已经开始了...",
    "text.npc6": "这个人真是太可恶了! 我一定要制裁他!",
    "text.npc7": "别着急, 这只怪兽看着真猛.",
    "text.npc8": "我一定有办法打倒他的....",
    "text.npc9": "不! 你不会摧毁后台城的!!!",
    "text.npc10": "你进入了副本",
    "text.npc11": "刷怪前请先点击页面空白处!!!",
    "text.npc12": "开始刷怪",
    "text.npc13": "你进入了商店",
    "text.npc14": "接下来你将面对强大的巨代码怪, 你可以通过 'W' 'A' 'S' 'D' 来打败它!",
    "text.plot1": "\n\u4ECE\u524D\u6709\u4E2A\u63A7\u5236\u53F0, \u63A7\u5236\u53F0\u91CC\u6709\u5EA7\u540E\u53F0\u57CE, \u540E\u53F0\u57CE\u4E2D\u6709\u8001\u6BD4\u7279\u548C\u5C0F\u6BD4\u7279\u4E24\u4EBA\u8FC7\u7740\u5E73\u51E1\u7684\u751F\u6D3B.\n\u800C\u4ECA\u5929\u5374\u662F\u4E0D\u5E73\u51E1\u7684\u4E00\u5929......\n   \n\u65E9\u4E0A, \u8001\u6BD4\u7279\u5E26\u7740\u5C0F\u6BD4\u7279\u53BB\u95E8\u53E3\u7684\u65E9\u70B9\u644A\u4E70\u65E9\u9910, \u5FFD\u7136\u542C\u89C1\u5929\u4E0A\u4F20\u6765\u4E00\u9635\u673A\u68B0\u58F0, \u4ED6\u4EEC\u62AC\u5934\u4E00\u770B, \u53D1\u73B0\u662F\u6709\u4EBA\u6765\u8BBF\u95EE\u7F51\u7AD9\u4E86!\n\u4ED6\u4EEC\u6240\u5728\u7684\u7F51\u7AD9\u662F\u4E00\u4E2A\u5C0F\u578B\u535A\u5BA2\u7F51\u7AD9, \u5E73\u65F6\u4E00\u822C\u6CA1\u4EBA\u8BBF\u95EE\u8FD9\u4E2A\u7AD9\u70B9, \u4F46\u662F\u4ECA\u5929\u5374\u6765\u4E86\u4E00\u4F4D\u8BBF\u5BA2.\n\u8FD9\u4F4D\u8BBF\u5BA2\u5934\u9876\u9ED1\u5E3D, \u8EAB\u7A7F\u9ED1\u8863, \u6234\u7740\u9ED1\u8272\u53E3\u7F69, \u9AD8\u9AD8\u7684\u9F3B\u6881\u4E0A\u67B6\u7740\u4E00\u526F\u58A8\u955C.\n    \n\"\u8FD9\u4EBA\u600E\u4E48\u8FD9\u526F\u6253\u626E\u554A?\" \"\u597D\u5947\u602A\u7684\u8BBF\u5BA2!\" \"\u771F\u4E0D\u77E5\u9053\u4ED6\u7A76\u7ADF\u6765\u5E72\u561B\" ....\n    \n\u8857\u4E0A\u7684\u4EBA\u4F60\u4E00\u8A00\u6211\u4E00\u8BED, \u8BA8\u8BBA\u7740\u8FD9\u4E2A\u5947\u602A\u7684\u4EBA.\n    \n\u5C0F\u6BD4\u7279\u5F00\u59CB\u610F\u8BC6\u5230\u4E8B\u60C5\u7684\u4E0D\u5BF9\u52B2, \u4E00\u822C\u6765\u8BF4, \u8BBF\u5BA2\u90FD\u662F\u535A\u5BA2\u4E3B\u7684\u670B\u53CB\u3001\u540C\u5B66\u6216\u8005\u5BB6\u4EBA, \u800C\u8FD9\u6B21\u6765\u7684\u4EBA\u5374\u4E0D\u80AF\u5C06\u81EA\u5DF1\u7684\u771F\u9762\u76EE\u5C55\u73B0\u51FA\u6765, \u8FD9\u771F\u662F\u592A\u53EF\u7591\u4E86!\n    \n\u7A81\u7136, \u4E00\u4E2A\u5DE8\u5927\u7684\u4EE3\u7801\u602A\u517D\u4ECE\u673A\u68B0\u58F0\u4E2D\u94BB\u4E86\u51FA\u6765, \u5B83\u5486\u54EE\u7740, \u5B83\u8981\u6467\u6BC1\u540E\u53F0\u57CE!!\n\u539F\u6765, \u8FD9\u53EA\u602A\u517D\u662F\u90A3\u4E2A\u9ED1\u8863\u8BBF\u5BA2\u53EC\u5524\u51FA\u6765\u7684, \u5B83\u5934\u4E0A\u957F\u7740\u5C16\u5C16\u7684\u7284\u89D2, \u4E24\u9897\u5C16\u7259\u95EA\u7740\u5BD2\u5149, \u4E00\u53CC\u773C\u775B\u4E2D\u900F\u7740\u6740\u6C14, \u6574\u4E2A\u5929\u7A7A\u5E03\u6EE1\u4E86\u6B7B\u7684\u6C14\u606F.\n   \n\"\u554A!!!.....\"\n\u8857\u4E0A\u7684\u4E00\u4E2A\u4EBA\u5FFD\u5730\u88AB\u602A\u517D\u6293\u4E86\u8D77\u6765, \u602A\u517D\u7528\u5B83\u7684\u7259\u9F7F\u6495\u54AC\u7740\u90A3\u4E2A\u4EBA, \u63A7\u5236\u53F0\u5F00\u59CB\u5927\u91CF\u8F93\u51FA\u8B66\u62A5:\n",
    "text.plot2": "有黑客入侵!! 后台正在被侵占!!!",
    "text.plot3": "接着便是更多的人被吃掉....",
    "text.plot4": "又过了几年.. 原本一派繁荣的后台城变得乌烟瘴气...",
    "text.plot5": "\n\u5DE8\u4EE3\u7801\u602A\u6B7B\u4E86, \u540E\u53F0\u57CE\u6062\u590D\u4E86\u539F\u672C\u7684\u7E41\u8363\u666F\u8C61.\n\u662F\u7684, \u4F60\u62EF\u6551\u4E86\u6574\u5EA7\u540E\u53F0\u57CE!!\n\n\u57CE\u4E2D\u7684\u4EBA\u4EEC\u6B22\u547C\u7740, \u96C0\u8DC3\u7740, \u5E86\u795D\u7740\u4F60\u7684\u80DC\u5229.\n\u800C\u5929\u7A7A\u4E2D\u7684\u9ED1\u5BA2\u5374\u8BF4: \"\u53EF\u6076! \u6211\u8FD8\u4F1A\u518D\u6765\u7684!\"\n\n......\n",
    "text.plot6": "巨代码怪出现在了你的面前, 你紧握着%s. 这一刻, 你充满了决心!!",
    "text.plot7": "只见, 代码怪扑了上来. 它咆哮着, 嘶吼着. 但是你知道, 你背负着后台城的命运, 你永远也不能认输!",
    "text.game_finish": "完",
    "text.g_prtc": "副本 (g_prtc)",
    "text.g_shop": "商店 (g_shop)",
    "text.mob.north": "在 上面 出现了一只 %s !",
    "text.mob.east": "在 右面 出现了一只 %s !",
    "text.mob.south": "在 下面 出现了一只 %s !",
    "text.mob.west": "在 左面 出现了一只 %s !",
    "text.boss.north": "巨代码怪出现在了 北边!",
    "text.boss.east": "巨代码怪出现在了 东边!",
    "text.boss.south": "巨代码怪出现在了 南边!",
    "text.boss.west": "巨代码怪出现在了 西边!",
    "text.save_detected": "检测到你有本地游戏存档, 已自动加载",
    "text.empty": "空"
};
